module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Top', {
    attrs: {
      "title": "Тест"
    }
  }, [_c('template', {
    slot: "backbtn"
  }, [_c('router-link', {
    staticClass: "top__link",
    attrs: {
      "to": {
        name: "profile-examination"
      }
    }
  }, [_vm._v("Назад")])], 1), (_vm.isLoading) ? _c('LoadingSpinner', {
    attrs: {
      "size": 100
    }
  }) : [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": "Ошибка"
    }
  }) : (!_vm.isStart && !_vm.isFinish) ? [_c('AppHeading', {
    attrs: {
      "level": "2",
      "mod": "bold, uppercase"
    }
  }, [_vm._v(_vm._s(_vm.item.name))]), (_vm.item.is_auto_complete) ? _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.item.auto_complete_text))]) : _vm._e(), (_vm.item.group_name) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_c('b', [_vm._v("Группа:")]), _vm._v(" " + _vm._s(_vm.item.group_name))]) : _vm._e(), (_vm.item.events_name) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_c('b', [_vm._v("Программа:")]), _vm._v(" " + _vm._s(_vm.item.events_name))]) : _vm._e(), (_vm.item.module_name) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_c('b', [_vm._v("Модуль:")]), _vm._v(" " + _vm._s(_vm.item.module_name))]) : _vm._e(), (_vm.item.theme_name) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_c('b', [_vm._v("Тема:")]), _vm._v(" " + _vm._s(_vm.item.theme_name))]) : _vm._e(), (_vm.item.lesson_name) ? _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_c('b', [_vm._v("Урок:")]), _vm._v(" " + _vm._s(_vm.item.lesson_name))]) : _vm._e(), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.item.description))]), _c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold, uppercase"
    }
  }, [_vm._v("ПРАВИЛА ПРОХОЖДЕНИЯ ТЕСТА")]), _c('AppList', {
    attrs: {
      "items": _vm.examinationRules
    }
  }), _c('ExtButton', {
    attrs: {
      "color": "green",
      "size": "small"
    },
    on: {
      "click": _vm.startTest
    }
  }, [_vm._v("Пройти тест")])] : _vm._e(), (_vm.isStart) ? [(_vm.questions.length) ? _c('div', {
    staticClass: "examination-item-questions"
  }, [(_vm.timer) ? _c('div', {
    staticClass: "examination-timer"
  }, [_c('div', [_vm._v(_vm._s((_vm.hours + ":" + _vm.minutes + ":" + _vm.seconds)))])]) : _vm._e(), _vm._l((_vm.questions), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "examination-item-questions-block"
    }, [_c('AppText', {
      attrs: {
        "mod": "bold"
      }
    }, [_vm._v(_vm._s(item.questionCount) + ". " + _vm._s(item.name))]), _vm._l((item.variants), function(variant, variantIndex) {
      return _c('div', {
        key: variant.id
      }, [(item.type === 2) ? _c('Checkbox', {
        staticClass: "examination-item-questions-input",
        attrs: {
          "disabled": _vm.isItemDisabled(variant, item)
        },
        model: {
          value: (variant.result),
          callback: function($$v) {
            _vm.$set(variant, "result", $$v)
          },
          expression: "variant.result"
        }
      }, [_vm._v(_vm._s(variant.name))]) : _vm._e(), (item.type === 1) ? _c('Radio', {
        staticClass: "examination-item-questions-input",
        attrs: {
          "disabled": _vm.isItemDisabled(variant, item),
          "value": variant.id,
          "label": variant.name,
          "id": variant.id
        },
        model: {
          value: (item.result),
          callback: function($$v) {
            _vm.$set(item, "result", $$v)
          },
          expression: "item.result"
        }
      }) : _vm._e()], 1)
    })], 2)
  }), (_vm.pagesCount === _vm.page) ? _c('ExtButton', {
    attrs: {
      "color": "green",
      "size": "small",
      "disabled": _vm.isReatyToFinish()
    },
    on: {
      "click": _vm.finishTest
    }
  }, [_vm._v("Завершить тест")]) : _vm._e(), _c('PaginationLayout', [(_vm.pagesCount > 1) ? _c('PaginatorDefault', {
    attrs: {
      "timeForQuestion": _vm.time_for_question,
      "isReatyToFinish": _vm.isReatyToFinish(),
      "count": _vm.pagesCount,
      "current": _vm.page,
      "max": 6
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }) : _vm._e()], 1)], 2) : _vm._e(), (!_vm.questions.length) ? _c('Warning', {
    attrs: {
      "isHeader": false
    }
  }, [_c('p', [_vm._v("На данный момент заданий нет.")])]) : _vm._e()] : _vm._e(), (_vm.isFinish) ? [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold, uppercase"
    }
  }, [_vm._v("Результаты последней попытки прохождения теста")]), _c('AppList', {
    attrs: {
      "items": _vm.resultFields
    }
  }), (_vm.next_attempt <= _vm.numberOfAttempts) ? _c('ExtButton', {
    attrs: {
      "color": "green",
      "size": "small"
    },
    on: {
      "click": _vm.runTestAgain
    }
  }, [_vm._v("Пройти тест заново")]) : _vm._e()] : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ed7d734","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/examination-item/examinationItem.vue
// module id = b839d42549257a56fcaa
// module chunks = 3